function redirectToDownloadIndex(to) {
  const search = new URLSearchParams(to.query).toString()
  window.location.replace(`/download/index.html${search ? `?${search}` : ''}`)
}

// prettier-ignore
const Routes = [
  {
    path: '/download', name: 'download', beforeEnter: redirectToDownloadIndex
  },
  {
    path: '/echo-download', name: 'echo-download', beforeEnter: redirectToDownloadIndex
  }
]
export default Routes
